/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Click_Submit_When_ReadyInputs */

const en_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Click the Submit button when you're ready to process ${i?.count} file(s).`)
};

const fr_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cliquez sur Soumettre lorsque vous êtes prêt à traiter ${i?.count} fichier(s).`)
};

const de_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Klicken Sie auf die Schaltfläche „Absenden“, wenn Sie bereit sind, die Datei(en) ${i?.count} zu verarbeiten.`)
};

const it_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fare clic sul pulsante Invia quando si è pronti a elaborare ${i?.count} file.`)
};

const ru_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Нажмите кнопку «Отправить», когда будете готовы обработать файл(ы) ${i?.count}.`)
};

const es_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Haga clic en el botón Enviar cuando esté listo para procesar ${i?.count} archivo(s).`)
};

const zh_cn2_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`准备好处理 ${i?.count} 文件时，单击“提交”按钮。`)
};

const ja_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ファイルを処理する準備ができたら、[送信] ボタンをクリックします。`)
};

const hi_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`जब आप ${i?.count} फ़ाइल(फ़ाइलों) को प्रोसेस करने के लिए तैयार हों, तो सबमिट बटन पर क्लिक करें।`)
};

const pt_pt2_click_submit_when_ready = /** @type {(inputs: Click_Submit_When_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Clique no botão Enviar quando estiver pronto para processar o(s) arquivo(s) ${i?.count}.`)
};

/**
* | output |
* | --- |
* | "Click the Submit button when you're ready to process {count} file(s)." |
*
* @param {Click_Submit_When_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const click_submit_when_ready = /** @type {((inputs: Click_Submit_When_ReadyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Click_Submit_When_ReadyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_click_submit_when_ready(inputs)
	if (locale === "de") return de_click_submit_when_ready(inputs)
	if (locale === "it") return it_click_submit_when_ready(inputs)
	if (locale === "ru") return ru_click_submit_when_ready(inputs)
	if (locale === "es") return es_click_submit_when_ready(inputs)
	if (locale === "zh-CN") return zh_cn2_click_submit_when_ready(inputs)
	if (locale === "ja") return ja_click_submit_when_ready(inputs)
	if (locale === "hi") return hi_click_submit_when_ready(inputs)
	if (locale === "pt-PT") return pt_pt2_click_submit_when_ready(inputs)
	return en_click_submit_when_ready(inputs)
});